import styled from 'styled-components';
import { backgroundSite } from '../../styles/stylesConstants';

export const LayoutWrapper = styled.div`
  background: ${backgroundSite};
  width: 100%;
  min-height: 100vh;
  height: 100%;
  position: relative;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 24px;
`;

export const ContainerPage = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 3 / 13;
  height: 100%;
  margin-bottom: 24px;

  .content-wrapper {
    max-width: 1016px;
    height: calc(100% - 65px);
    overflow-y: auto;
    width: 100%;
    padding: 16px 24px 0 0;
    position: relative;
  }
`;
